export default __webpack_public_path__ + "static/media/logo-white.6af6765a.png";